module.exports = __webpack_public_path__ + "static/img/map.6f0b788.png";


//////////////////
// WEBPACK FOOTER
// ./static/主页素材图/map.png
// module id = rPyQ
// module chunks = 1